class CancelablePromise {
	constructor(promise) {
		this.canceled = false
		this.internalPromise = promise
	}
	cancel() {
		this.canceled = true 
	}
	run() {
		return new Promise((resolve, reject) => {
			this.internalPromise.then((data) => {
				if(!this.canceled) {
					resolve(data)
				}
			})
			.catch((data) => {
				if(!this.canceled) {
					reject(data)
				}
			})
		})
	}
}

export default CancelablePromise